<template>
  <layout :title="pageTitle">
    <hr />
    <b-tabs>
      <b-tab-item label="All Users">
        <view-users-table
          :users="users"
          show="all"
          title="Users"
          :per-page="20"
        />
      </b-tab-item>
      <b-tab-item label="Participants">
        <view-users-table
          :users="participants"
          show="participants"
          title="Participants"
          :per-page="20"
        />
      </b-tab-item>
      <b-tab-item label="Feedback Givers">
        <view-users-table
          :users="feedbackgivers"
          show="feedbackgivers"
          title="Feedback Givers"
          :per-page="20"
        />
      </b-tab-item>
    </b-tabs>
  </layout>
</template>

<script>
import Layout from './Layout';
import viewUsersTable from '../../Components/Management/ViewUsersTable';

export default {
  components: {
    Layout,
    viewUsersTable,
  },
  props: {
    users: Array,
  },
  data() {
    return {
      pageTitle: 'Manage Users',
    };
  },
  computed: {
    participants: function () {
      return this.users.filter((user) => user.projects.length > 0);
    },
    feedbackgivers: function () {
      return this.users.filter((user) => user.feedbackProjects);
    },
  },
};
</script>
